/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo, useState, useEffect } from "react";
import { Modal, Table, Space, Button, Typography, Tag, Empty } from "antd";

import { formatMoney } from "../../../../utils/util";

const num = (v) => Number(v || 0);

/* เลือก MOQ ของสินค้าในใบสั่งซื้อ
   record.lots = รายการ MOQ ที่ผูกไว้กับผู้ขายรายนี้ */
export default function ModalSelectLot({ open, close, record, confirm }) {
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    if (open) setSelected(record?.lot_size ?? null);
  }, [open, record]);

  const rows = useMemo(
    () =>
      (record?.lots || []).map((l, i) => {
        const size = num(l.lot_size);
        return {
          key: `${l.lot_size}-${i}`,
          lot_name: l.lot_name || "",
          lot_size: l.lot_size,
          lot_price: l.lot_price,
          unit_price: size ? num(l.lot_price) / size : 0,
        };
      }),
    [record]
  );

  const handleConfirm = () => {
    const lot = rows.find((r) => Number(r.lot_size) === Number(selected));
    if (!lot) return;
    confirm(lot);
    close(false);
  };

  const columns = [
    {
      title: "ชื่อ MOQ",
      dataIndex: "lot_name",
      render: (v) => v || <Typography.Text type="secondary">-</Typography.Text>,
    },
    {
      title: "ขนาด (จำนวน)",
      dataIndex: "lot_size",
      width: 130,
      align: "right",
      render: (v) => formatMoney(num(v), 0),
    },
    {
      title: "ราคาต่อ MOQ",
      dataIndex: "lot_price",
      width: 130,
      align: "right",
      render: (v) => formatMoney(num(v), 2, 2),
    },
    {
      title: "ราคา/หน่วย",
      dataIndex: "unit_price",
      width: 120,
      align: "right",
      render: (v) => (
        <Typography.Text type="success">{formatMoney(num(v), 2, 2)}</Typography.Text>
      ),
    },
  ];

  const ButtonModal = (
    <Space direction="horizontal" size="middle">
      <Button onClick={() => close(false)}>ปิด</Button>
      <Button type="primary" disabled={selected === null} onClick={handleConfirm}>
        ยืนยันการเลือก
      </Button>
    </Space>
  );

  return (
    <Modal
      open={open}
      title={
        <Space size={8} wrap>
          <span>เลือก MOQ</span>
          {record?.stcode && <Tag color="blue">{record.stcode}</Tag>}
          <Typography.Text type="secondary">{record?.stname}</Typography.Text>
        </Space>
      }
      onCancel={() => close(false)}
      footer={ButtonModal}
      maskClosable={false}
      width={720}
      style={{ top: 40 }}
    >
      <Table
        size="small"
        bordered
        rowKey="key"
        columns={columns}
        dataSource={rows}
        pagination={false}
        scroll={{ y: 320 }}
        rowClassName={(r) =>
          Number(r.lot_size) === Number(selected) ? "ant-table-row-selected" : ""
        }
        onRow={(r) => ({
          style: { cursor: "pointer" },
          onClick: () => setSelected(r.lot_size),
          onDoubleClick: () => {
            setSelected(r.lot_size);
            confirm(r);
            close(false);
          },
        })}
        rowSelection={{
          type: "radio",
          selectedRowKeys: rows
            .filter((r) => Number(r.lot_size) === Number(selected))
            .map((r) => r.key),
          onChange: (_, selectedRows) => setSelected(selectedRows[0]?.lot_size),
        }}
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="ผู้ขายรายนี้ยังไม่ได้ตั้ง MOQ ให้สินค้านี้"
            />
          ),
        }}
      />
      <Typography.Text type="secondary" style={{ fontSize: 12 }}>
        เลือกแล้วระบบจะตั้งจำนวนเท่ากับขนาด MOQ และคำนวณราคาต่อหน่วยให้อัตโนมัติ (ดับเบิลคลิกเพื่อเลือกทันที)
      </Typography.Text>
    </Modal>
  );
}
